<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5D5NYb/img/1_2.png?1705026943039" alt="This image is the cover for the book Another Year Finds Me in Texas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Another Year Finds Me in Texas
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In </b><b>one of the few women’s diaries from Civil War–era Texas</b><b>, a Northerner trapped in the Confederacy at the outbreak of war recounts her experience.</b></p><p>Lucy Pier Stevens, a twenty-one-year-old woman from Ohio, came to visit her aunt’s family near Bellville, Texas, on Christmas Day, 1859. Little did she know how drastically her life would change on April 4, 1861, when the outbreak of the Civil War made returning home impossible. Stranded in enemy territory for the duration of the war, how would she reconcile her Northern upbringing with the Southern sentiments surrounding her?</p><p>Lucy Stevens’s diary offers a unique perspective on daily life at the fringes of America’s bloodiest conflict. An educated and keen observer, Stevens took note of everything—the weather, illnesses, food shortages, parties, church attendance, chores, schools, childbirth, death, the family’s slaves, and political and military news.</p> As Stevens confided her private thoughts to her journal, she revealed how her love for her Texas family and the Confederate soldiers she came to know blurred her loyalties. Showing how the ties of heritage, kinship, friendship, and community transcended the sharpest division in US history, this rare diary and Vicki Adams Tongate’s insightful historical commentary on it provide a trove of information on women’s history, Texas history, and Civil War history.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vicki Adams Tongate
      </h2>
      
      <p class="authorDescription body article">Vicki Adams Tongate spent twenty years at Southern Methodist University, teaching and researching the Lucy Pier Stevens diary. She has now retired and lives in Fort Worth, Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University Of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61f4e346